import $ from "jquery";
import c from "common";
import Bacon from "Bacon";
import tooltip from "tooltip";
import ga from "analytics";
import support from "support";

var $body = $(document.body);

function toggleError(state, $target) {
  $target.find('input[type="text"], input[type="password"], input[type="tel"]').toggleClass("error", state);
}

function toggleProgress($target, isLoading, submitButtonElement) {
  $target.find("input").prop("disabled", isLoading);

  var submitButton = $target.find("input[type='submit'], input[type='button']:not(.no-progress)");

  if (submitButtonElement) {
    submitButton = submitButtonElement;
  }
  toggleProgressButton(submitButton, isLoading);
  toggleProgressButtonText(submitButton, isLoading);
}

function toggleProgressButton(button, isLoading) {
  button.prop('disabled', isLoading).toggleClass("progress", isLoading);
}

function toggleProgressButtonText(button, isLoading) {
  if (button.attr("data-progress-label") && button.attr("data-default-label")) {
    button.val(isLoading ? button.attr("data-progress-label") : button.attr("data-default-label"));
  }
}

function bubbleHover(selector, html) {
  function initQtipOnTarget(event) {
    var $target = $(event.target);
    $($target).qtip({
      content: {
        text: html
      },
      position: {
        my: 'bottom center',
        at: 'top center',
        viewport: $(window)
      },
      show: {
        event: event.type,
        ready: true,
        solo: true
      }
    }, event);
  }

  $body.asEventStream("mouseenter", selector).filter(!support.isMobile()).onValue(initQtipOnTarget);
  $body.asEventStream("click", selector).filter(support.isMobile).onValue(initQtipOnTarget);
}

function isLoginValuesSet() {
  return c.nonEmpty($("#username_modal").val()) && c.nonEmpty($("#password_modal").val());
}

function enableLoginSubmit(enable) {
  var $submit = $(".modal-login input[type='submit']");
  if (enable && c.isTrue(enable)) {
    $submit.removeAttr("disabled");
  } else {
    $submit.attr("disabled", "disabled");
  }
}

function triggerLoginInputs() {
  $("#username_modal").trigger('input');
  $("#password_modal").trigger('input');
}

function initTriggerInputsOnFocus() {
  $body.asEventStream("focus", "#username_modal").onValue(function () {
    Bacon.interval(200).takeWhile(function () {
      return $("#username_modal").is(":focus");
    }).onValue(triggerLoginInputs);
  });
}

function initInfoTooltip() {
  $body.asEventStream("mouseover", ".info-button").onValue(function (event) {
    tooltip.show(event, $(event.target).find('span').html(), {
      hide: {
        fixed: true,
        delay: 300
      },
      events: {
        show: function () {
          ga.trackWithSection("show-info-text");
        }
      }
    });
  });
}

export default {
  toggleError: toggleError,
  toggleProgress: toggleProgress,
  toggleProgressButton: toggleProgressButton,
  toggleProgressButtonText: toggleProgressButtonText,
  bubbleHover: bubbleHover,
  modalLoginValuesSet: isLoginValuesSet,
  modalLoginEnableSubmit: enableLoginSubmit,
  modalTriggerLoginInputs: triggerLoginInputs,
  triggerInputsOnFocus: initTriggerInputsOnFocus,
  initInfoTooltip: initInfoTooltip
};



// WEBPACK FOOTER //
// ./web/js/form-helpers.js